<template>
  <Info>
    Login Failed. This is often due to disabled third party cookies. After
    enabling them please <a href="/">log in again</a>. If you've landed here
    again after enabling them please reach out using the contact info below.
  </Info>
</template>

<script>
export default {
  name: "InvalidLoginTicket",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
};
</script>

<style scoped></style>
